<template>
  <div class="container">
    <Menu />

    <div id="log-page">
      <div class="is-flex is-justify-between log-toolbar">
        <div class="is-flex log-toolbar-left">
          <input
            v-model="tuKhoa"
            class="input"
            type="text"
            :placeholder="lang('Search')"
          >
          <span class="log-dem">{{ dongDaLoc.length }} / {{ dong.length }}</span>
        </div>
        <div class="is-flex log-toolbar-right">
          <a class="button is-small" :class="{ 'is-loading': dangTai }" @click="taiLai">
            <b-icon icon="redo" size="is-small" />
          </a>
          <a class="button is-small" @click="taiXuong">
            <b-icon icon="download" size="is-small" /> {{ lang('Download') }}
          </a>
          <a class="button is-small is-danger is-outlined" @click="xoaLog">
            <b-icon icon="trash-alt" size="is-small" /> {{ lang('Delete') }}
          </a>
        </div>
      </div>

      <p v-if="bịCắtBớt" class="log-canhbao">
        {{ lang('Log truncated notice', soDongHienThi) }}
      </p>

      <div class="log-khung">
        <div v-if="!dangTai && !dong.length" class="log-rong">{{ lang('Nothing to display') }}</div>
        <div
          v-for="(d, i) in dongHienThi"
          :key="i"
          class="log-dong"
          :class="mucCuaDong(d)"
        >{{ d }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Menu from './partials/Menu'
import api from '../api/api'

export default {
  name: 'Logs',
  components: { Menu },
  data() {
    return {
      dong: [],
      tuKhoa: '',
      dangTai: false,
      bịCắtBớt: false,
      soDongHienThi: 1000,
    }
  },
  computed: {
    dongDaLoc() {
      if (!this.tuKhoa.trim()) return this.dong
      const k = this.tuKhoa.toLowerCase()
      return this.dong.filter(d => d.toLowerCase().indexOf(k) !== -1)
    },
    dongHienThi() {
      // Dong moi nhat len tren cho de theo doi loi vua xay ra
      return this.dongDaLoc.slice().reverse()
    },
  },
  mounted() {
    this.taiLai()
  },
  methods: {
    mucCuaDong(d) {
      if (/\.(CRITICAL|ALERT|EMERGENCY)\b/.test(d)) return 'log-critical'
      if (/\.ERROR\b/.test(d)) return 'log-error'
      if (/\.WARNING\b/.test(d)) return 'log-warning'
      return 'log-thuong'
    },
    taiLai() {
      this.dangTai = true
      api.getLog({ lines: this.soDongHienThi })
        .then(ret => {
          this.dong = ret.lines
          this.bịCắtBớt = ret.truncated
          this.dangTai = false
        })
        .catch(error => {
          this.dangTai = false
          this.handleError(error)
        })
    },
    taiXuong() {
      window.open(Vue.config.baseURL + '/downloadlog', '_blank')
    },
    xoaLog() {
      this.$dialog.confirm({
        message: this.lang('Are you sure you want to do this?'),
        type: 'is-danger',
        cancelText: this.lang('Cancel'),
        confirmText: this.lang('Confirm'),
        onConfirm: () => {
          api.clearLog()
            .then(() => {
              this.dong = []
              this.$toast.open({
                message: this.lang('Deleted'),
                type: 'is-success',
              })
            })
            .catch(error => this.handleError(error))
        },
      })
    },
  },
}
</script>

<style scoped>
#log-page { margin: 50px 0 30px 0; }
.log-toolbar { margin-bottom: 14px; flex-wrap: wrap; gap: 10px; }
.log-toolbar-left { align-items: center; gap: 10px; }
.log-toolbar-right { gap: 8px; }
.log-toolbar-left .input { max-width: 320px; }
.log-dem { color: #7a7a7a; font-size: .85rem; white-space: nowrap; }
.log-canhbao {
  background: #fff8e6;
  border: 1px solid #ffe6a8;
  color: #a87400;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: .85rem;
  margin-bottom: 12px;
}
.log-khung {
  background: #1e1e1e;
  border-radius: 8px;
  padding: 14px 16px;
  max-height: 65vh;
  overflow-y: auto;
  font-family: 'Cascadia Code', Consolas, 'Courier New', monospace;
  font-size: .82rem;
  line-height: 1.6;
}
.log-rong { color: #8a8a8a; padding: 20px; text-align: center; }
.log-dong {
  white-space: pre-wrap;
  word-break: break-word;
  color: #d4d4d4;
  border-bottom: 1px solid rgba(255,255,255,.05);
  padding: 3px 0;
}
.log-critical, .log-error { color: #ff8a8a; }
.log-warning { color: #ffc72c; }
</style>
